<template>
    <!--表格组件，需要分页-->
    <div>
        <el-table
            :data="pageData"
            tooltip-effect="dark"
            style="width: 100%"
            :border="true"
            @selection-change='selectRowInfo'>
            <el-table-column type="selection" width="45px"></el-table-column>
            <el-table-column label="序号" width="62px" type="index"></el-table-column>
                <template v-for='(col) in tableColumns'>
                    <el-table-column
                        sortable
                        :show-overflow-tooltip="true"
                        :prop="col.prop"
                        :label="col.label"
                        :key="col.id"
                        width="124px">
                    </el-table-column>
                </template>
            <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-edit-outline" title="修改" circle @click.stop="handleNavDepartmentEdit(scope.row.id)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDepartmentDelete(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-row type="flex" justify="end">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :total="page.totalPageNum"
                :current-page="page.currentPage"
                :page-size="page.pageSize"
                @current-change="queryFormData"
            />
        </el-row> -->
    </div>
</template>

<script>
    export default {
        name: 'RenderFormList',
        data: function () {
            return {
                pageData: []
            };
        },
        props: {
            tableColumns: {
                type: Array,
                required: true
            }
        },
        methods: {
            selectRowInfo (val) {
                // console.log(val);
                // this.selectArr = val;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/RenderFormList/RenderFormList.vue